/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdSetOverview } from './AdSetOverview';
import {
    AdSetOverviewFromJSON,
    AdSetOverviewFromJSONTyped,
    AdSetOverviewToJSON,
    AdSetOverviewToJSONTyped,
} from './AdSetOverview';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface SingleCampaignOverview
 */
export interface SingleCampaignOverview {
    /**
     * 
     * @type {MoneyOutput}
     * @memberof SingleCampaignOverview
     */
    cpa?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof SingleCampaignOverview
     */
    cpm?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof SingleCampaignOverview
     */
    cpc?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    pnoNet?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    pnoGross?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    roasNet?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    roasGross?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    poasNet?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    poasGross?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    ctr?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    conversionRateNet?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    conversionRateGross?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof SingleCampaignOverview
     */
    profitNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof SingleCampaignOverview
     */
    profitGross?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    profitPercentNet?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    profitPercentGross?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    unverifiedLeads?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    verifiedLeads?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    ordersNet?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    ordersGross?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof SingleCampaignOverview
     */
    turnoverNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof SingleCampaignOverview
     */
    turnoverGross?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof SingleCampaignOverview
     */
    spendGoodsNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof SingleCampaignOverview
     */
    spendGoodsGross?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof SingleCampaignOverview
     */
    spendMarketing?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    clicks?: number;
    /**
     * 
     * @type {number}
     * @memberof SingleCampaignOverview
     */
    impressions?: number;
    /**
     * 
     * @type {string}
     * @memberof SingleCampaignOverview
     */
    remoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleCampaignOverview
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleCampaignOverview
     */
    integrationName?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleCampaignOverview
     */
    statusName?: string;
    /**
     * 
     * @type {string}
     * @memberof SingleCampaignOverview
     */
    status?: string;
    /**
     * 
     * @type {Array<AdSetOverview>}
     * @memberof SingleCampaignOverview
     */
    adSets?: Array<AdSetOverview>;
}

/**
 * Check if a given object implements the SingleCampaignOverview interface.
 */
export function instanceOfSingleCampaignOverview(value: object): value is SingleCampaignOverview {
    return true;
}

export function SingleCampaignOverviewFromJSON(json: any): SingleCampaignOverview {
    return SingleCampaignOverviewFromJSONTyped(json, false);
}

export function SingleCampaignOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): SingleCampaignOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'cpa': json['cpa'] == null ? undefined : MoneyOutputFromJSON(json['cpa']),
        'cpm': json['cpm'] == null ? undefined : MoneyOutputFromJSON(json['cpm']),
        'cpc': json['cpc'] == null ? undefined : MoneyOutputFromJSON(json['cpc']),
        'pnoNet': json['pnoNet'] == null ? undefined : json['pnoNet'],
        'pnoGross': json['pnoGross'] == null ? undefined : json['pnoGross'],
        'roasNet': json['roasNet'] == null ? undefined : json['roasNet'],
        'roasGross': json['roasGross'] == null ? undefined : json['roasGross'],
        'poasNet': json['poasNet'] == null ? undefined : json['poasNet'],
        'poasGross': json['poasGross'] == null ? undefined : json['poasGross'],
        'ctr': json['ctr'] == null ? undefined : json['ctr'],
        'conversionRateNet': json['conversionRateNet'] == null ? undefined : json['conversionRateNet'],
        'conversionRateGross': json['conversionRateGross'] == null ? undefined : json['conversionRateGross'],
        'profitNet': json['profitNet'] == null ? undefined : MoneyOutputFromJSON(json['profitNet']),
        'profitGross': json['profitGross'] == null ? undefined : MoneyOutputFromJSON(json['profitGross']),
        'profitPercentNet': json['profitPercentNet'] == null ? undefined : json['profitPercentNet'],
        'profitPercentGross': json['profitPercentGross'] == null ? undefined : json['profitPercentGross'],
        'unverifiedLeads': json['unverifiedLeads'] == null ? undefined : json['unverifiedLeads'],
        'verifiedLeads': json['verifiedLeads'] == null ? undefined : json['verifiedLeads'],
        'ordersNet': json['ordersNet'] == null ? undefined : json['ordersNet'],
        'ordersGross': json['ordersGross'] == null ? undefined : json['ordersGross'],
        'turnoverNet': json['turnoverNet'] == null ? undefined : MoneyOutputFromJSON(json['turnoverNet']),
        'turnoverGross': json['turnoverGross'] == null ? undefined : MoneyOutputFromJSON(json['turnoverGross']),
        'spendGoodsNet': json['spendGoodsNet'] == null ? undefined : MoneyOutputFromJSON(json['spendGoodsNet']),
        'spendGoodsGross': json['spendGoodsGross'] == null ? undefined : MoneyOutputFromJSON(json['spendGoodsGross']),
        'spendMarketing': json['spendMarketing'] == null ? undefined : MoneyOutputFromJSON(json['spendMarketing']),
        'clicks': json['clicks'] == null ? undefined : json['clicks'],
        'impressions': json['impressions'] == null ? undefined : json['impressions'],
        'remoteId': json['remoteId'] == null ? undefined : json['remoteId'],
        'name': json['name'] == null ? undefined : json['name'],
        'integrationName': json['integrationName'] == null ? undefined : json['integrationName'],
        'statusName': json['statusName'] == null ? undefined : json['statusName'],
        'status': json['status'] == null ? undefined : json['status'],
        'adSets': json['adSets'] == null ? undefined : ((json['adSets'] as Array<any>).map(AdSetOverviewFromJSON)),
    };
}

export function SingleCampaignOverviewToJSON(json: any): SingleCampaignOverview {
    return SingleCampaignOverviewToJSONTyped(json, false);
}

export function SingleCampaignOverviewToJSONTyped(value?: SingleCampaignOverview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cpa': MoneyOutputToJSON(value['cpa']),
        'cpm': MoneyOutputToJSON(value['cpm']),
        'cpc': MoneyOutputToJSON(value['cpc']),
        'pnoNet': value['pnoNet'],
        'pnoGross': value['pnoGross'],
        'roasNet': value['roasNet'],
        'roasGross': value['roasGross'],
        'poasNet': value['poasNet'],
        'poasGross': value['poasGross'],
        'ctr': value['ctr'],
        'conversionRateNet': value['conversionRateNet'],
        'conversionRateGross': value['conversionRateGross'],
        'profitNet': MoneyOutputToJSON(value['profitNet']),
        'profitGross': MoneyOutputToJSON(value['profitGross']),
        'profitPercentNet': value['profitPercentNet'],
        'profitPercentGross': value['profitPercentGross'],
        'unverifiedLeads': value['unverifiedLeads'],
        'verifiedLeads': value['verifiedLeads'],
        'ordersNet': value['ordersNet'],
        'ordersGross': value['ordersGross'],
        'turnoverNet': MoneyOutputToJSON(value['turnoverNet']),
        'turnoverGross': MoneyOutputToJSON(value['turnoverGross']),
        'spendGoodsNet': MoneyOutputToJSON(value['spendGoodsNet']),
        'spendGoodsGross': MoneyOutputToJSON(value['spendGoodsGross']),
        'spendMarketing': MoneyOutputToJSON(value['spendMarketing']),
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'remoteId': value['remoteId'],
        'name': value['name'],
        'integrationName': value['integrationName'],
        'statusName': value['statusName'],
        'status': value['status'],
        'adSets': value['adSets'] == null ? undefined : ((value['adSets'] as Array<any>).map(AdSetOverviewToJSON)),
    };
}

